// extracted by mini-css-extract-plugin
export var dropdown = "_e8-0";
export var imagePlaceholder = "_e8-2";
export var imageWrapper = "_e8-3";
export var productImage = "_e8-1";
export var truncateContainer = "_e8-4";
export var truncateText = "_e8-5";